// @ts-nocheck
import { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { Card } from 'primereact/card';
import { InputSwitch } from 'primereact/inputswitch';
import { Divider } from 'primereact/divider';
import { Slider } from 'primereact/slider';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import "../assets/functionalComponents/_dialog.scss"
import "../assets/functionalComponents/_dataItem.scss"

export const LightSettingComponents = (props) => {
    const [lightRendering, setLightRendering] = useState(true);
    const [lightScattering, setLightScattering] = useState(false);
    const [modelShadow, setModelShadow] = useState(false);
    const [useTimeLine, setUseTimeLine] = useState(true);
    const [lightAzimuth, setLightAzimuth] = useState(45);
    const [lightZenith, setLightZenith] = useState(45);
    const toast = useRef(null);

    useEffect(() => {
        if (window.main.OView === undefined)
            return;
        window.main.OView.enableLight = lightRendering;
        let lightProperty = window.main.OView.lightProperty;
        if (lightProperty === undefined)
            return;
        lightProperty.isAbs = useTimeLine;
        lightProperty.isAutoUpdateByDate = useTimeLine;
        lightProperty.azimuthAngle = lightAzimuth;
        lightProperty.zenithAngle = lightZenith;
        window.main.OView.lightProperty = lightProperty;
    }, [lightRendering, useTimeLine, lightAzimuth, lightZenith])

    useEffect(() => {
        if (window.main.OView === undefined)
            return;
        window.main.OView.enableVolumetricLightScattering = lightScattering;
    }, [lightScattering])

    useEffect(() => {
        if (window.main.OView === undefined)
            return;
        window.main.OView.enableShadow = modelShadow;
    }, [modelShadow])

    const gotoNow = () => {
        window.widgetTimeline.updateTime(new Date());
    }

    return (
        <div>
            <Toast ref={toast} />
            <Dialog header="日光設定" visible={props.LightSetting} modal={false} keepInViewport={false} onHide={() => props.onHide('LightSetting')}>
                <Card>
                    <div className="field grid">
                        <label class="col-12 mb-4 md:col-4 md:mb-0">日光渲染：</label>
                        <div className="col-12 md:col-8">
                            <InputSwitch checked={lightRendering} onChange={(e) => setLightRendering(e.value)} />
                        </div>
                    </div>
                    <Divider />
                    {
                        lightRendering ?
                            <div>
                                <div className="field grid">
                                    <label class="col-12 mb-4 md:col-4 md:mb-0">光線散射：</label>
                                    <div className="col-12 md:col-8">
                                        <InputSwitch checked={lightScattering} onChange={(e) => setLightScattering(e.value)} />
                                    </div>
                                </div>
                                <Divider />
                                <div className="field grid">
                                    <label class="col-12 mb-4 md:col-4 md:mb-0">建物陰影：</label>
                                    <div className="col-12 md:col-8">
                                        <InputSwitch checked={modelShadow} onChange={(e) => setModelShadow(e.value)} />
                                    </div>
                                </div>
                                <Divider />
                                <div className="field grid">
                                    <label class="col-12 mb-4 md:col-4 md:mb-0">跟隨時間軸：</label>
                                    <div className="col-12 md:col-8">
                                        <InputSwitch checked={useTimeLine} onChange={(e) => setUseTimeLine(e.value)} />
                                    </div>
                                </div>
                                <Card>
                                    {
                                        !useTimeLine ?
                                            <div>
                                                <div className="field grid">
                                                    <label class="col-12 mb-4 md:col-4 md:mb-0">方位角： {lightAzimuth}°</label>
                                                    <div className="col-12 md:col-8">
                                                        <Slider id="lightAzimuth" value={lightAzimuth} onChange={(e) => setLightAzimuth(e.value)} min={0} max={360} />
                                                    </div>
                                                </div>
                                                <div className="field grid">
                                                    <label class="col-12 mb-4 md:col-4 md:mb-0">天頂角： {lightZenith}°</label>
                                                    <div className="col-12 md:col-8">
                                                        <Slider id="lightZenith" value={lightZenith} onChange={(e) => setLightZenith(e.value)} min={0} max={90} />
                                                    </div>
                                                </div>
                                            </div> :
                                            <div>
                                                <Button label="回到現在時間" className="p-button-rounded p-button-info" onClick={gotoNow} style={{ width: "100%" }} />
                                            </div>
                                    }
                                </Card>
                            </div> : null
                    }
                </Card>
            </Dialog>
        </div>
    );
}